import React, { useEffect, useState } from 'react'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { createPortal } from 'react-dom'
import './Settings.css'

function DieFace({ pips }) {
  const dots = pips === 6
    ? [[8.2, 7.2], [15.8, 7.2], [8.2, 12], [15.8, 12], [8.2, 16.8], [15.8, 16.8]]
    : [[8.2, 8.2], [15.8, 8.2], [12, 12], [8.2, 15.8], [15.8, 15.8]]

  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.5" y="3.5" width="17" height="17" rx="3.5" stroke="currentColor" strokeWidth="1.6" />
      {dots.map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="1.15" fill="currentColor" />
      ))}
    </svg>
  )
}

const Settings = ({ numberOfPlayers, setNumberOfPlayers, gameType, setGameType, onResetGame }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return undefined
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  return (
    <div className="settings-container">
      <button
        type="button"
        className="yatzy-settings-button"
        aria-label="Indstillinger"
        onClick={() => setOpen(true)}
      >
        <SettingsOutlinedIcon />
      </button>

      {open ? createPortal(
        <div className="yatzy-settings-backdrop" onClick={() => setOpen(false)}>
          <div
            className="yatzy-settings-paper"
            role="dialog"
            aria-modal="true"
            aria-labelledby="yatzy-settings-title"
            onClick={(event) => event.stopPropagation()}
          >
            <h2 id="yatzy-settings-title" className="yatzy-settings-title">Indstillinger</h2>
            <div className="yatzy-settings-body">
              <section className="yatzy-settings-row">
                <p>Spillere</p>
                <div className="yatzy-settings-stepper">
                  <button
                    type="button"
                    aria-label="Fjern spiller"
                    disabled={numberOfPlayers <= 1}
                    onClick={() => setNumberOfPlayers(Math.max(1, numberOfPlayers - 1))}
                  >
                    −
                  </button>
                  <span>{numberOfPlayers}</span>
                  <button
                    type="button"
                    aria-label="Tilføj spiller"
                    disabled={numberOfPlayers >= 10}
                    onClick={() => setNumberOfPlayers(Math.min(10, numberOfPlayers + 1))}
                  >
                    +
                  </button>
                </div>
              </section>

              <section className="yatzy-settings-row">
                <p>Terninger</p>
                <div className="yatzy-settings-choice">
                  <button
                    type="button"
                    className={gameType === 'fiveDice' ? 'is-selected' : ''}
                    aria-label="5 terninger"
                    onClick={() => setGameType('fiveDice')}
                  >
                    <DieFace pips={5} />
                  </button>
                  <button
                    type="button"
                    className={gameType === 'sixDice' ? 'is-selected' : ''}
                    aria-label="6 terninger"
                    onClick={() => setGameType('sixDice')}
                  >
                    <DieFace pips={6} />
                  </button>
                </div>
              </section>

              <button
                type="button"
                className="settings-reset"
                onClick={() => {
                  onResetGame()
                  setOpen(false)
                }}
              >
                Nulstil spil
              </button>
            </div>
          </div>
        </div>,
        document.body,
      ) : null}
    </div>
  )
}

export default Settings
